export default function PageJsonLd() {
  const baseUrl = 'https://business-training.by';
  const pageUrl = `${baseUrl}/enciklopediya-korporativnogo-obucheniya/adaptaciya-sotrudnikov`;

  const breadcrumb = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Главная', item: { '@id': baseUrl, name: 'Главная' } },
      { '@type': 'ListItem', position: 2, name: 'Энциклопедия корпоративного обучения', item: { '@id': `${baseUrl}/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie`, name: 'Энциклопедия корпоративного обучения' } },
      { '@type': 'ListItem', position: 3, name: 'Адаптация новых сотрудников', item: { '@id': pageUrl, name: 'Адаптация новых сотрудников' } },
    ],
  };

  const service = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Адаптация новых сотрудников',
    description:
      'Система онбординга персонала для бизнеса. Программы адаптации, наставничество, чек-листы, оценка эффективности и обучение новых сотрудников.',
    provider: {
      '@type': 'Person',
      name: 'Алексей Сивко',
      jobTitle: 'Бизнес-тренер, практикующий консультант',
      url: baseUrl,
    },
    areaServed: { '@type': 'Place', name: 'Беларусь, Россия, Казахстан, Израиль' },
    serviceType: 'Корпоративное обучение и развитие персонала',
    url: pageUrl,
  };

  const person = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Алексей Сивко',
    jobTitle: 'Бизнес-тренер, практикующий консультант',
    description:
      'Практикующий бизнес-тренер с 18+ лет опыта. 100+ корпоративных проектов, 450+ тренингов, 4500+ участников. Компании Беларуси, России, Казахстана и Израиля.',
    url: baseUrl,
    sameAs: [
      'https://www.linkedin.com/in/sivko-trainer',
      'https://www.instagram.com/sivko_trainer',
    ],
    knowsAbout: [
      'Адаптация персонала',
      'Онбординг сотрудников',
      'Корпоративное обучение',
      'Наставничество',
      'Развитие сотрудников',
      'HR процессы',
    ],
  };

  const faqQuestions = [
    {
      '@type': 'Question',
      name: 'Что такое адаптация сотрудников?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Адаптация сотрудников — это системный процесс ввода нового работника в должность, знакомства с корпоративной культурой, правилами и задачами. Цель — чтобы сотрудник быстро вышел на требуемый уровень эффективности и стал полноценным членом команды.',
      },
    },
    {
      '@type': 'Question',
      name: 'Что такое онбординг?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Онбординг (onboarding) — современный термин для адаптации персонала, который подразумевает комплексную программу ввода сотрудника в компанию. Включает welcome-программу, обучение, наставничество, чек-листы и регулярную обратную связь.',
      },
    },
    {
      '@type': 'Question',
      name: 'Чем адаптация отличается от испытательного срока?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Испытательный срок — юридический статус сотрудника (обычно до 3 месяцев). Адаптация — HR-процесс, который может длиться от 2 недель до 6+ месяцев и направлен на интеграцию сотрудника в компанию и его профессиональное развитие.',
      },
    },
    {
      '@type': 'Question',
      name: 'Сколько длится адаптация сотрудника?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Базовая адаптация — 2-4 недели, полная интеграция — 3-6 месяцев. Для руководителей и сложных должностей — до года. Длительность зависит от должности, сложности продукта и корпоративной культуры компании.',
      },
    },
    {
      '@type': 'Question',
      name: 'Кто отвечает за адаптацию новых сотрудников?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'HR-специалист, непосредственный руководитель и наставник работают в связке. HR координирует процесс, руководитель ставит задачи и даёт обратную связь, наставник обучает и помогает освоиться в ежедневной работе.',
      },
    },
    {
      '@type': 'Question',
      name: 'Нужен ли наставник для адаптации?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Да, наставник критически важен для адаптации. Он помогает новичку освоить рабочие процессы, отвечает на вопросы, делится опытом и поддерживает в первые недели. Наставник сокращает время выхода на KPI в 1,5-2 раза.',
      },
    },
    {
      '@type': 'Question',
      name: 'Что входит в программу адаптации сотрудников?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Welcome-программа (знакомство с компанией), наставничество, чек-листы, план обучения на испытательный срок, доступ к базе знаний, регламенты работы, регулярные встречи с руководителем, промежуточная и финальная оценка.',
      },
    },
    {
      '@type': 'Question',
      name: 'Как оценить эффективность адаптации?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Эффективность измеряется по времени выхода на KPI, текучести в первые 3-6 месяцев, вовлеченности, оценке руководителя и самооценке сотрудника на контрольных точках.',
      },
    },
    {
      '@type': 'Question',
      name: 'Какие ошибки совершают компании при адаптации?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Главные ошибки: бросить новичка «разбирайся сам», отсутствие наставника, перегруз информацией в первый день, исчезновение руководителя, отсутствие оценки и обратной связи, отсутствие стандартов адаптации.',
      },
    },
    {
      '@type': 'Question',
      name: 'Как адаптировать удалённых сотрудников?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Для удалённых сотрудников нужен онлайн-онбординг: видеозвонки-знакомства, электронные чек-листы, доступ к базе знаний, регулярные онлайн-встречи с руководителем и наставником, виртуальные welcome-мероприятия.',
      },
    },
    {
      '@type': 'Question',
      name: 'Можно ли внедрить систему адаптации самостоятельно?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Можно, но процесс займёт больше времени и сопряжён с типичными ошибками. Профессиональное внедрение с экспертом ускоряет результат в 2-3 раза за счёт готовых методик, чек-листов и опыта работы с десятками компаний.',
      },
    },
  ];

  const faqPage = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqQuestions,
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>
      <script type="application/ld+json">{JSON.stringify(service)}</script>
      <script type="application/ld+json">{JSON.stringify(person)}</script>
      <script type="application/ld+json">{JSON.stringify(faqPage)}</script>
    </>
  );
}